// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-collection-A":"A_power-ocean-collection-A__PREdR"};